/* eslint-disable  @typescript-eslint/no-explicit-any */
export interface CustomToolbarProps extends React.PropsWithChildren<any> {}

export enum CalendarAction {
  CURRENT = 'CURRENT',
  PREV = 'PREV',
  NEXT = 'NEXT',
  TODAY = 'TODAY',
}
